export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur']

export const BUBBLE_SIZE = 64;
export const MARGIN = 24;
export const SUPPORTED_IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/tif',
    'image/tiff'
    ];

export const isSupportedImage = (file) => {
        const mimeType = file.type?.toLowerCase();
        const extension = file.name.split('.').pop()?.toLowerCase();

        return (
            SUPPORTED_IMAGE_TYPES.includes(mimeType) ||
            (
                ['tif', 'tiff'].includes(extension) &&
                (!mimeType || ['application/octet-stream'].includes(mimeType))
            )
        );
    };